import { createReducer, on } from '@ngrx/store';
import { Pagination } from 'src/app/core';
import {
  LineType,
  Plan,
  PlanClass,
  PlanStatus,
  PreProvPlan,
} from 'src/app/core/proto';
import {
  actionPlanSet,
  actionPlanGet,
  actionPlanGetSuccess,
  actionPlansGet,
  actionPlansGetSuccess,
  actionPlansGetFailure,
  actionPlanDestroy,
} from 'src/app/core/store/plans/plans.actions';

export interface PlansState {
  brandId?: string;
  displayName?: string;
  status?: PlanStatus | PlanStatus[];
  lineType?: LineType | LineType[];
  class?: PlanClass | PlanClass[];
  pagerResponse?: Pagination;
  plans?: Plan[];
  isLoadingPlans?: boolean;
  planId?: string;
  plan?: Plan;
  isLoadingPlan?: boolean;
}

const initialState: PlansState = {
  brandId: undefined,
  displayName: undefined,
  status: undefined,
  lineType: undefined,
  class: undefined,
  pagerResponse: {},
  plans: [],
  isLoadingPlans: true,
  planId: undefined,
  plan: undefined,
  isLoadingPlan: true,
};

export const planReducer = createReducer(
  initialState,
  on(actionPlansGet, (state, action) => {
    return {
      ...state,
      brandId: action.body.brandId || undefined,
      status: action.body.status || undefined,
      displayName: action.body.displayName || undefined,
      class: action.body.class || undefined,
      lineType: action.body.lineType || undefined,
      isLoadingPlans: true,
    };
  }),
  on(actionPlansGetSuccess, (state, action) => {
    return {
      ...state,
      plans: action.payload?.plans || [],
      pagerResponse: action.payload?.pagerResponse || {},
      isLoadingPlans: false,
    };
  }),
  on(actionPlansGetFailure, (state, action) => {
    return {
      ...state,
      isLoadingPlans: false,
    };
  }),
  on(actionPlanGet, (state, action) => {
    return {
      ...state,
      planId: action.params?.planId || undefined,
      isLoadingPlan: true,
    };
  }),
  on(actionPlanGetSuccess, (state, action) => {
    return {
      ...state,
      plan: action.payload?.plan || undefined,
      isLoadingPlan: false,
    };
  }),
  on(actionPlanSet, (state, action) => {
    return {
      ...state,
      plan: action.payload?.plan || undefined,
      isLoadingPlan: false,
    };
  }),
  on(actionPlanDestroy, () => {
    return initialState;
  })
);
